<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(17)"
      :class="index == 17 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 17" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 17"
      />
      <div>生产线</div>
    </div>
    <div
      class="button"
      @click="selectMenu(18)"
      :class="index == 18 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 18" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 18"
      />
      <div>视频监控</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
  <style>

</style>
